import { useMemo } from 'preact/hooks'
import { decodeHTML } from '@/components/helpers/utils'

export function SearchPageLink({ children, query, className, type }) {
  const link = type === 'search' ? `/search?query=${encodeURIComponent(query)}` : query

  const parsedChildren = useMemo(() => {
    if (typeof children !== 'string') return children
    return decodeHTML(children)
  }, [children])
  return (
    <a href={link} className={className}>
      {parsedChildren}
    </a>
  )
}
